import type { Vec2 } from '../../geo/types';
import type { BridgeDeck } from '../../site/types';
import { WORLD } from '../../core/config';
import { fromRing, union } from '../../geo/clip';
import { ensureCCW } from '../../geo/polygon';
import type { MeshBuilder, VertexStyle } from '../mesh/meshBuilder';
import { buildBridgeSolid } from './bridgeSolid';

/** Join the water-clipped deck and dry-bank landings without coincident internal walls. */
export function buildKartuizersDeck(
  builder: MeshBuilder,
  style: VertexStyle,
  bridge: BridgeDeck
): boolean {
  if (bridge.id !== 'bridge-kartuizers-entry') return false;
  const dx = bridge.b[0] - bridge.a[0],
    dy = bridge.b[1] - bridge.a[1],
    length = Math.hypot(dx, dy),
    across: Vec2 = [(-dy * bridge.width) / (2 * length), (dx * bridge.width) / (2 * length)],
    offset = (p: Vec2, sign: number): Vec2 => [p[0] + sign * across[0], p[1] + sign * across[1]],
    span = fromRing(
      ensureCCW([
        offset(bridge.a, 1),
        offset(bridge.b, 1),
        offset(bridge.b, -1),
        offset(bridge.a, -1),
      ])
    );
  for (const piece of union([...bridge.deck, span]))
    buildBridgeSolid(
      builder,
      style,
      piece,
      () => WORLD.groundY - 0.35,
      () => WORLD.groundY
    );
  return true;
}
